import '../css/aviso-privacidad.css'

const AvisoPrivacidad = () => {
    return (
        <>
            <div className="text-center mb-4 justify-content">
                <h4 className="fw-bold">Aviso de Privacidad</h4>
                <p className="text-muted mb-0 subtitle">Última actualización: 11 de junio de 2025</p>
            </div>

            <div className="container mb-4 justify-content">
                <div className="row">
                    <div className="col-md-8 offset-md-2">
                        <p>
                            <strong>KJ-LOGISTICS</strong> <span className="enfasis">("nosotros", "nuestro" o "nos")</span> está
                            comprometido a proteger tu privacidad. Esta Política de Privacidad explica cómo se recopila, utiliza
                            y divulga tu información personal por KJ-LOGISTICS.
                            <br /><br />
                            Esta Política de Privacidad se aplica a nuestro website, y sus subdominios asociados
                            (colectivamente, nuestro "Servicio") junto con nuestra página administrativa, KJ-LOGISTICS. Al
                            acceder o usar nuestro Servicio, manifiestas que has leído, entendido y aceptas nuestra
                            recopilación, almacenamiento, uso y divulgación de tu información personal según se describe en esta
                            Política de Privacidad y nuestros Términos de Servicio.
                        </p>
                    </div>
                </div>
            </div>



            <div className="container">
                <div className="row mb-4 align-items-start p-4">
                    <div className="col-md-4 text-md-end">
                        <h6>1.Definiciones y términos clave</h6>
                    </div>
                    <div className="col-md-8 justify-content">
                        <p>Para ayudar a explicar las cosas de la manera más clara posible en esta Política de Privacidad, cada
                            vez que se haga referencia a alguno de estos términos, se definen estrictamente como:


                            <li>
                                <span>Compañía: </span>cuando esta política menciona "Compañía", "nosotros", "nos" o "nuestro",
                                se refiere a KARLA JOSIMAR LOGISTICS SA DE CV, (QUERÉTARO, C.P. 76147), que
                                es responsable de su información bajo esta Política de Privacidad.
                            </li>

                            <li>
                                <span>País:</span>donde KJ-LOGISTICS o los propietarios/fundadores de KJ-LOGISTICS están
                                basados, en este caso es MÉXICO
                            </li>

                            <li>
                                <span>Cliente:</span> se refiere a la empresa, organización o persona que es registrada para
                                usar los servicios de KJ-LOGISTICS para gestionar las herramientas proporcionadas.
                            </li>

                            <li>
                                <span>Dispositivo:</span> cualquier dispositivo conectado a Internet, como un teléfono, tableta,
                                computadora o cualquier otro dispositivo que se pueda usar para visitar KJ-LOGISTICS y usar los
                                servicios.
                            </li>

                            <li>
                                <span>Dirección IP:</span> A cada dispositivo conectado a Internet se le asigna un número
                                conocido como dirección de Protocolo de Internet (IP). Estos números generalmente se asignan en
                                bloques geográficos. Una dirección IP a menudo se puede usar para identificar la ubicación desde
                                la cual un dispositivo se está conectando a Internet.
                            </li>

                            <li>
                                <span>Personal:</span> se refiere a aquellas personas que están empleadas por KJ-LOGISTICS o
                                están bajo contrato para realizar un servicio en nombre de una de las partes.
                            </li>

                            <li>
                                <span>Data Personal:</span>cualquier información que directa o indirectamente, o en conexión con
                                otra información, incluida un número de identificación personal, permita la identificación o
                                identificabilidad de una persona física.
                            </li>

                            <li>
                                <span>Servicio:</span>se refiere al servicio proporcionado por KJ-LOGISTICS como se describe en
                                los términos relativos (si están disponibles) y en esta plataforma.
                            </li>

                            <li>
                                <span>Servicio de terceros:</span>se refiere a anunciantes, patrocinadores de concursos, socios
                                promocionales y de marketing, y otros que proporcionan nuestro contenido o cuyos productos o
                                servicios creemos que pueden interesarte.
                            </li>

                            <li>
                                KJ-LOGISTICS’s sitio, que se puede acceder a través de esta URL:
                                <a href="https://kj-logistics.com/" target="_blank" rel="noreferrer"> https://kj-logistics.com/ </a>
                                <span> ó </span>
                                <a href=" https://app.kj-logistics.com/" target="_blank" rel="noreferrer">https://app.kj-logistics.com/</a>
                            </li>
                        </p>
                        <br />
                        <br />
                    </div>


                    <div className="row mb-4 align-items-start p-4">
                        <div className="col-md-4 text-md-end">
                            <h6>2. ¿Qué información recopilamos?</h6>
                        </div>
                        <div className="col-md-8 justify-content">
                            <p>
                                Recopilamos información tuya cuando visitas nuestro website, cuando se te registra en nuestro
                                website como cliente o proveedor, subes algún documento solicitado por el sistema, proporcionas
                                información por los canales oficiales de KJ-LOGISTICS (whatsapp, correo electrónico, entre
                                otros.)
                            </p>
                        </div>
                    </div>

                    <div className="row mb-4 align-items-start p-4">
                        <div className="col-md-4 text-md-end">
                            <h6>3. ¿Compartimos la información que recopilamos con terceros?</h6>
                        </div>
                        <div className="col-md-8 justify-content">
                            <p>Podemos compartir la información que recopilamos, tanto personal como no personal, con terceros
                                como anunciantes, proveedores, clientes, socios promocionales y de marketing, y otros que
                                proporcionan nuestro contenido o cuyos productos o servicios creemos que pueden interesarte.
                                También podemos compartirla con nuestras empresas afiliadas actuales y futuras y socios
                                comerciales, y si estamos involucrados en una fusión, venta de activos u otra reorganización
                                empresarial, también podemos compartir o transferir tu información personal y no personal a
                                nuestros sucesores en interés.
                                <br />
                                <br />
                                Podemos contratar proveedores de servicios externos de confianza para realizar funciones y
                                proporcionarnos servicios, como alojar y mantener nuestros servidores y el website,
                                almacenamiento y gestión de bases de datos, gestión de correo electrónico, marketing de
                                almacenamiento, procesamiento de tarjetas de crédito, servicio al cliente y cumplimiento de
                                pedidos de productos y servicios que pueda ser registrado a través del website. Es probable que
                                compartamos tu información personal, y posiblemente alguna información no personal, con estos
                                terceros para que puedan realizar estos servicios para nosotros y para ti.
                                <br /><br />
                                Podemos compartir porciones de nuestros datos de archivos de registro, incluidas direcciones IP,
                                con fines analíticos con terceros como socios de análisis web, desarrolladores de aplicaciones y
                                redes publicitarias. Si se comparte tu dirección IP, se puede usar para estimar la ubicación
                                general y otros datos tecnográficos, como la velocidad de conexión, si has visitado el website
                                en una ubicación compartida y el tipo de dispositivo utilizado para visitar el website.
                                <br /><br />
                                También podemos divulgar información personal y no personal sobre ti a funcionarios
                                gubernamentales o policiales o a partes privadas si, a nuestra entera discreción, creemos que es
                                necesario o apropiado para responder a reclamaciones, procesos legales (incluidas citaciones),
                                para proteger nuestros derechos e intereses o los de un tercero, la seguridad del público o de
                                cualquier persona, para prevenir o detener cualquier actividad ilegal, poco ética o legalmente
                                procesable, o para cumplir con las órdenes judiciales, leyes, normas y regulaciones aplicables.
                            </p>
                        </div>
                    </div>


                    <div className="row mb-4 align-items-start p-4">
                        <div className="col-md-4 text-md-end">
                            <h6>4.¿Dónde y cuándo se recopila la información de clientes y usuarios finales?</h6>
                        </div>
                        <div className="col-md-8 justify-content">
                            <p>
                                KJ-LOGISTICS recopilar información personal que nos envíes. También podemos recibir información
                                personal sobre ti de terceros, como se describe anteriormente.
                                Todo esto a través de nuestros canales oficiales de comunicación descritos en nuestros websites.
                                <br />
                                <br />
                                <br />
                            </p>
                        </div>

                        <div className="col-md-4 text-md-end">
                            <h6>5.¿Cómo usamos la información que recopilamos?</h6>
                        </div>
                        <div className="col-md-8 justify-content">
                            <p>
                                Cualquiera de la información que recopilamos de ti puede usarse de las siguientes maneras:
                                <li>
                                    Para personalizar tu experiencia (tu información nos ayuda a responder mejor a tus
                                    necesidades individuales)
                                </li>

                                <li>
                                    Para mejorar el servicio al cliente (tu información nos ayuda a realizar más eficazmente a
                                    tus solicitudes de servicio al cliente, necesidades de soporte y proveedor)
                                </li>

                                <li>
                                    Para procesar transacciones.
                                </li>

                                <li>
                                    Para administrar facturas, entregas, recolecciones, embarques, encuesta u otra función que
                                    nos permita cumplir nuestro servicio.
                                </li>

                                <li>
                                    Para enviar correos electrónicos periódicos.
                                </li>
                            </p>
                            <br />
                            <br />
                        </div>

                        <div className="col-md-4 text-md-end">
                            <h6>6.¿Cómo usamos tu dirección de correo electrónico?</h6>
                        </div>
                        <div className="col-md-8 justify-content">
                            <p>
                                Al enviar tu dirección de correo electrónico para este website, aceptas recibir correos
                                electrónicos de nosotros. Puedes cancelar tu participación en cualquiera de estas listas de
                                correo electrónico en cualquier momento haciendo clic en el enlace de exclusión voluntaria u
                                otra opción de cancelación de suscripción que se incluye en el correo electrónico
                                correspondiente. Solo enviamos correos electrónicos a personas que nos han autorizado a
                                contactarlas, ya sea directamente o a través de un tercero. No enviamos correos electrónicos
                                comerciales no solicitados, porque odiamos el spam tanto como tú. Al enviar tu dirección de
                                correo electrónico, también aceptas permitirnos usar tu dirección de correo electrónico para la
                                orientación de audiencia de clientes en sitios como Facebook, donde mostramos publicidad
                                personalizada a personas específicas que han optado por recibir comunicaciones de nosotros. Las
                                direcciones de correo electrónico enviadas solo a través de la página de procesamiento de
                                pedidos se utilizarán únicamente para enviarte información y actualizaciones relacionadas con tu
                                pedido. Sin embargo, si nos has proporcionado el mismo correo electrónico a través de otro
                                método, podemos usarlo para cualquiera de los fines establecidos en esta Política.
                                <br />
                                <span className="texto-cursiva">Nota: Si en algún momento deseas darte de baja para no recibir
                                    futuros correos electrónicos, incluimos instrucciones detalladas para cancelar la
                                    suscripción al final de cada correo electrónico.</span>
                            </p>
                            <br />
                            <br />

                        </div>

                        <div className="col-md-4 text-md-end">
                            <h6>7.¿Cuánto tiempo conservamos tu información?</h6>
                        </div>
                        <div className="col-md-8 justify-content">
                            <p>
                                Conservamos tu información solo mientras la necesitemos para cumplir con los fines descritos en
                                esta política. Esto también se aplica a cualquier persona con la que compartamos tu información
                                y que realice servicios en nuestro nombre. Cuando ya no necesitemos usar tu información y no
                                haya necesidad de que la conservemos para cumplir con nuestras obligaciones legales o
                                reglamentarias, la eliminaremos de nuestros sistemas o la despersonalizaremos para que no
                                podamos identificarte.
                            </p>
                            <br />
                            <br />
                        </div>

                        <div className="col-md-4 text-md-end">
                            <h6>8.¿Cómo protegemos tu información?</h6>
                        </div>
                        <div className="col-md-8 justify-content">
                            <p>
                                Implementamos una variedad de medidas de seguridad para mantener la seguridad de tu información
                                personal cuando realizas un pedido o ingresas, envías o accedes a tu información personal.
                                Ofrecemos el uso de un servidor seguro. Toda la información confidencial/crédito proporcionada
                                se transmite a través de la tecnología Secure Socket Layer (SSL) y luego se cifra en la base de
                                datos de nuestros proveedores, y solo puede ser accesible por aquellos autorizados con derechos
                                de acceso especiales a dichos sistemas, y están obligados a mantener la información
                                confidencial. Tu información privada (tarjetas de crédito, números de seguro social, datos
                                financieros, etc.) son almacenadas con las políticas establecidas que proporcionan los servicios
                                de AWS. Sin embargo, no podemos asegurar ni garantizar la seguridad absoluta de cualquier
                                información que transmitas a KJ-LOGISTICS o garantizar que tu información en el Servicio no
                                pueda ser accedida, divulgada, alterada o destruida por una violación de cualquiera de nuestras
                                medidas de seguridad físicas, técnicas o administrativas.
                            </p>
                            <br />
                            <br />
                        </div>


                        <div className="col-md-4 text-md-end">
                            <h6>9.¿Podría transferirse mi información a otros países?</h6>
                        </div>
                        <div className="col-md-8 justify-content">
                            <p>
                                KJ-LOGISTICS está incorporado en MÉXICO. Información recopilada a través de nuestro website, a
                                través de interacciones directas contigo, o del uso de nuestros servicios de ayuda, puede
                                transferirse de vez en cuando a nuestras oficinas o personal, o a terceros, ubicados en todo el
                                mundo, y puede verse y alojarse en cualquier parte del mundo, incluidos países que pueden no
                                tener leyes de aplicabilidad general que regulen el uso y la transferencia de dichos datos. En
                                la máxima medida permitida por la ley aplicable, al utilizar cualquiera de los anteriores,
                                consientes voluntariamente la transferencia transfronteriza y el alojamiento de dicha
                                información.
                            </p>
                            <br />
                            <br />
                        </div>

                        <div className="col-md-4 text-md-end">
                            <h6>10.¿La información recopilada a través de KJ-LOGISTICS Service es segura?</h6>
                        </div>
                        <div className="col-md-8 justify-content">
                            <p>
                                Tomamos precauciones para proteger la seguridad de tu información. Tenemos procedimientos
                                físicos, electrónicos y administrativos para ayudar a proteger, prevenir el acceso no
                                autorizado, mantener la seguridad de los datos y usar correctamente tu información. Sin embargo,
                                ni las personas ni los sistemas de seguridad son infalibles, incluidos los sistemas de cifrado.
                                Además, las personas pueden cometer delitos intencionales, cometer errores o no seguir las
                                políticas. Por lo tanto, aunque hacemos esfuerzos razonables para proteger tu información
                                personal, no podemos garantizar su seguridad absoluta. Si la ley aplicable impone cualquier
                                deber que no se pueda renunciar para proteger tu información personal, aceptas que la mala
                                conducta intencional será el estándar utilizado para medir nuestro cumplimiento de ese deber.
                            </p>
                            <br />
                            <br />
                        </div>

                        <div className="col-md-4 text-md-end">
                            <h6>11.¿Puedo actualizar o corregir mi información?</h6>
                        </div>
                        <div className="col-md-8 justify-content">
                            <p>
                                Los derechos que tienes para solicitar actualizaciones o correcciones a la información
                                KJ-LOGISTICS depende de tu relación con KJ-LOGISTICS. El personal puede actualizar o corregir su
                                información según lo detallado en nuestras políticas internas de empleo de la empresa.
                                <br /><br />
                                Los clientes tienen derecho a solicitar la restricción de ciertos usos y divulgaciones de
                                información de identificación personal de la siguiente manera. Puedes contactarnos para (1)
                                actualizar o corregir tu información de identificación personal, (2) cambiar tus preferencias
                                con respecto a las comunicaciones y otra información que recibes de nosotros, o (3) eliminar la
                                información de identificación personal mantenida sobre ti en nuestros sistemas (sujeto al
                                siguiente párrafo), cancelando tu cuenta. Dichas actualizaciones, correcciones, cambios y
                                eliminaciones no tendrán ningún efecto en otra información que mantenemos, o en la información
                                que hemos proporcionado a terceros de acuerdo con esta Política de Privacidad antes de dicha
                                actualización, corrección, cambio o eliminación. Para proteger tu privacidad y seguridad,
                                podemos tomar medidas razonables (como solicitar una contraseña única) para verificar tu
                                identidad antes de otorgar acceso al perfil o realizar correcciones. Eres responsable de
                                mantener la confidencialidad de tu contraseña única y la información de tu cuenta en todo
                                momento.
                                <br /><br />
                                Debes saber que no es tecnológicamente posible eliminar todos y cada uno de los registros de la
                                información que nos has proporcionado de nuestro sistema. La necesidad de hacer copias de
                                seguridad de nuestros sistemas para proteger la información de la pérdida inadvertida significa
                                que puede existir una copia de tu información en una forma no borrable que será difícil o
                                imposible de localizar para nosotros. Inmediatamente después de recibir tu solicitud, toda la
                                información personal almacenada en las bases de datos que utilizamos activamente y otros medios
                                de búsqueda fácil se actualizarán, corregirán, cambiarán o eliminarán, según corresponda, tan
                                pronto como sea razonable y técnicamente posible.
                                <br /><br />
                                Si eres un usuario final y deseas actualizar, eliminar o recibir cualquier información que
                                tenemos sobre ti, puedes hacerlo contactando a la organización de la que eres cliente.
                            </p>
                            <br />
                            <br />
                        </div>

                        <div className="col-md-4 text-md-end">
                            <h6>12.Personal</h6>
                        </div>
                        <div className="col-md-8 justify-content">
                            <p>
                                Si eres un KJ-LOGISTICS trabajador o solicitante, recopilamos información que nos proporcionas
                                voluntariamente. Usamos la información recopilada para fines de Recursos Humanos con el fin de
                                administrar beneficios a los trabajadores y seleccionar a los solicitantes.
                                <br /><br />
                                Puedes contactarnos para (1) actualizar o corregir tu información, (2) cambiar tus preferencias
                                con respecto a las comunicaciones y otra información que recibes de nosotros, o (3) recibir un
                                registro de la información que tenemos sobre ti. Dichas actualizaciones, correcciones, cambios y
                                eliminaciones no tendrán ningún efecto en otra información que mantenemos, o en la información
                                que hemos proporcionado a terceros de acuerdo con esta Política de Privacidad antes de dicha
                                actualización, corrección, cambio o eliminación.
                            </p>
                            <br />
                            <br />
                        </div>


                        <div className="col-md-4 text-md-end">
                            <h6>13.Venta del negocio</h6>
                        </div>
                        <div className="col-md-8 justify-content">
                            <p>
                                Nos reservamos el derecho de transferir información a un tercero en el caso de una venta, fusión
                                u otra transferencia de todos o sustancialmente todos los activos de KJ-LOGISTICS o cualquiera
                                de sus Afiliados Corporativos (como se define aquí), o esa parte de KJ-LOGISTICS o cualquiera de
                                sus Afiliados Corporativos a los que se refiere el Servicio, o en el caso de que descontinuemos
                                nuestro negocio o presentemos una petición o se presente en nuestra contra una petición de
                                quiebra, reorganización o procedimiento similar, siempre que el tercero acepte cumplir con los
                                términos de esta Política de Privacidad.
                            </p>
                            <br />
                            <br />
                        </div>

                        <div className="col-md-4 text-md-end">
                            <h6>14.Afiliados</h6>
                        </div>
                        <div className="col-md-8 justify-content">
                            <p>
                                Podemos divulgar información (incluida información personal) sobre ti a nuestros Afiliados
                                Corporativos. A los efectos de esta Política de Privacidad, "Afiliado Corporativo" significa
                                cualquier persona o entidad que directa o indirectamente controla, es controlada por o está bajo
                                control común con KJ-LOGISTICS, ya sea por propiedad o de otra manera. Cualquier información
                                relacionada contigo que proporcionemos a nuestros Afiliados Corporativos será tratada por esos
                                Afiliados Corporativos de acuerdo con los términos de esta Política de Privacidad.
                            </p>
                            <br />
                            <br />
                        </div>

                        <div className="col-md-4 text-md-end">
                            <h6>15.Ley aplicable</h6>
                        </div>
                        <div className="col-md-8 justify-content">
                            <p>
                                Esta Política de Privacidad se rige por las leyes de MÉXICO sin tener en cuenta su disposición
                                sobre conflictos de leyes. Aceptas la jurisdicción exclusiva de los tribunales en relación con
                                cualquier acción o disputa que surja entre las partes en virtud de o en relación con esta
                                Política de Privacidad, excepto para aquellas personas que puedan tener derechos para presentar
                                reclamaciones en virtud del Privacy Shield o el marco Suiza-EE.UU.
                                <br /><br />
                                Las leyes de MEXICO, excluyendo sus reglas de conflictos de leyes, regirán este Acuerdo y tu uso
                                del website. Tu uso del website también puede estar sujeto a otras leyes locales, estatales,
                                nacionales o internacionales.
                                <br /><br />
                                Al usar KJ-LOGISTICS o contactarnos directamente, manifiestas tu aceptación de esta Política de
                                Privacidad. Si no estás de acuerdo con esta Política de Privacidad, no debes interactuar con
                                nuestro website, o usar nuestros servicios. El uso continuo del website, interacción directa con
                                nosotros, o seguir la publicación de cambios en esta Política de Privacidad que no afecten
                                significativamente el uso o la divulgación de tu información personal, significará que aceptas
                                esos cambios.
                                <br /><br />
                                Nos comprometemos a mantener la seguridad de sus datos personales y a cumplir con las leyes
                                aplicables en materia de privacidad y protección de datos, incluyendo la Ley Federal de
                                Protección de Datos Personales en Posesión de Particulares y su Reglamento, así como a los
                                lineamientos del Instituto Nacional de Acceso a la Información y Protección de Datos (INAI). Si
                                tiene alguna pregunta o inquietud sobre nuestro aviso de privacidad, por favor contáctanos.
                                <br /><br />
                                <a href="https://home.inai.org.mx" target="_blank" rel="noreferrer">INAI</a>
                            </p>
                            <br />
                            <br />
                        </div>

                        <div className="col-md-4 text-md-end">
                            <h6>16.Tu consentimiento</h6>
                        </div>
                        <div className="col-md-8 justify-content">
                            <p>
                                Hemos actualizado nuestra Política de Privacidad para brindarle total transparencia sobre lo que
                                se establece cuando visita nuestro sitio y cómo se utiliza. Al usar KJ-LOGISTICS, registrar una
                                cuenta o realizar algún uso de los servicios, aceptas nuestra Política de Privacidad y aceptas
                                sus Términos.
                            </p>
                            <br />
                            <br />
                        </div>

                        <div className="col-md-4 text-md-end">
                            <h6>17.Enlaces a otros sitios web</h6>
                        </div>
                        <div className="col-md-8 justify-content">
                            <p>
                                Esta Política de Privacidad se aplica únicamente a los Servicios. Los Servicios pueden contener
                                enlaces a otros sitios web que no son operados ni controlados por KJ-LOGISTICS. No somos
                                responsables del contenido, la precisión o las opiniones expresadas en dichos sitios web, y
                                dichos sitios web no son investigados, monitoreados ni verificados en cuanto a su precisión o
                                integridad por nosotros. Recuerda que cuando usas un enlace para ir de los Servicios a otro
                                sitio web, nuestra Política de Privacidad ya no está en vigor. Tu navegación e interacción en
                                cualquier otro sitio web, incluidos aquellos que tienen un enlace en nuestra plataforma, están
                                sujetos a las propias reglas y políticas de ese sitio web. Dichos terceros pueden usar sus
                                propias cookies u otros métodos para recopilar información sobre ti.
                            </p>
                            <br />
                            <br />
                        </div>

                        <div className="col-md-4 text-md-end">
                            <h6>18.Privacidad de los niños</h6>
                        </div>
                        <div className="col-md-8 justify-content">
                            <p>
                                No nos dirigimos a nadie menor de 18 años. No recopilamos conscientemente información de
                                identificación personal de nadie menor de 18 años. Si eres padre o tutor y eres consciente de
                                que tu hijo nos ha proporcionado Datos Personales, comunícate con nosotros. Si nos damos cuenta
                                de que hemos recopilado Datos Personales de alguien menor de 18 años sin verificación del
                                consentimiento de los padres, tomamos medidas para eliminar esa información de nuestros
                                servidores.
                            </p>
                            <br />
                            <br />
                        </div>

                        <div className="col-md-4 text-md-end">
                            <h6>19.Cambios a nuestra política de privacidad</h6>
                        </div>
                        <div className="col-md-8 justify-content">
                            <p>
                                KJ Logistics se reserva el derecho de actualizar y/o modificar periódicamente el presente aviso
                                de privacidad para reflejar los cambios que se produzcan en nuestros servicios. Será
                                responsabilidad del usuario revisar periódicamente el contenido del aviso de privacidad en
                                nuestro sitio. A menos que la ley exija lo contrario, te notificaremos (por ejemplo, a través de
                                nuestro Servicio) antes de realizar cambios en esta Política de Privacidad y te daremos la
                                oportunidad de revisarlos antes de que entren en vigor. Luego, si continúas usando el Servicio,
                                estarás sujeto a la Política de Privacidad actualizada. Si no deseas aceptar esta o cualquier
                                Política de Privacidad actualizada, puedes eliminar tu cuenta.
                            </p>
                            <br />
                            <br />
                        </div>

                        <div className="col-md-4 text-md-end">
                            <h6>20.Servicios de terceros</h6>
                        </div>
                        <div className="col-md-8 justify-content">
                            <p>
                                Podemos mostrar, incluir o poner a disposición contenido de terceros (incluidos datos,
                                información, aplicaciones y otros servicios de productos) o proporcionar enlaces a sitios web o
                                servicios de terceros ("Servicios de Terceros").
                                <br /><br />
                                Reconoces y aceptas que KJ-LOGISTICS no será responsable de ningún Servicio de Terceros,
                                incluida su precisión, integridad, puntualidad, validez, cumplimiento de derechos de autor,
                                legalidad, decencia, calidad o cualquier otro aspecto de los mismos. KJ-LOGISTICS no asume ni
                                tendrá ninguna responsabilidad contigo ni con ninguna otra persona o entidad por ningún Servicio
                                de Terceros.
                                <br /><br />
                                Los Servicios de Terceros y los enlaces a ellos se proporcionan únicamente como una conveniencia
                                para ti y accedes y los utilizas completamente bajo tu propio riesgo y sujetos a los términos y
                                condiciones de dichos terceros.
                            </p>
                            <br />
                            <br />
                        </div>

                        <div className="col-md-4 text-md-end">
                            <h6>21.Tecnologías de seguimiento</h6>
                        </div>
                        <div className="col-md-8 justify-content">
                            <p>

                                <li>
                                    <span>Almacenamiento Local</span>
                                    <br /><br />
                                    El Almacenamiento Local, a veces conocido como almacenamiento DOM, proporciona a las
                                    aplicaciones web métodos y protocolos para almacenar datos del lado del cliente. El
                                    almacenamiento web admite el almacenamiento de datos persistente, similar a las cookies,
                                    pero con una capacidad enormemente mejorada y sin información almacenada en el encabezado de
                                    la solicitud HTTP.
                                </li>
                                <br />
                                <li>
                                    <span>Sesiones</span>
                                    <br /><br />
                                    Usamos "Sesiones" para identificar las áreas de nuestra plataforma que has visitado. Una
                                    Sesión es una pequeña pieza de datos almacenada en tu computadora o dispositivo móvil por tu
                                    navegador web.
                                </li>
                            </p>
                            <br />
                            <br />
                            <br />
                        </div>

                        <h5>Información sobre el Reglamento General</h5>
                        <br />
                        <br />
                        <div>
                            <span className="h5-subtitle">¿Qué es la información personal?</span><br /><br />
                            Cualquier dato que se relacione con una persona identificable o identificada. El INAI cubre una
                            amplia gama de información que podría usarse por sí sola o en combinación con otras piezas de
                            información para identificar a una persona. Los datos personales van más allá del nombre o la
                            dirección de correo electrónico de una persona. Algunos ejemplos incluyen información financiera,
                            opiniones políticas, datos genéticos, datos biométricos, direcciones IP, dirección física,
                            orientación sexual y etnia.

                            Los Principios de Protección de Datos incluyen requisitos tales como:
                            <div className="last-list ">
                                <li>
                                    Los datos personales recopilados deben procesarse de manera justa, legal y transparente y solo
                                    deben usarse de una manera que una persona razonablemente esperaría.
                                </li>
                                <br />
                                <li>
                                    Los datos personales sólo deben recopilarse para cumplir un propósito específico y solo deben
                                    usarse para ese propósito. Las organizaciones deben especificar por qué necesitan los datos
                                    personales cuando los recopilan.
                                </li>
                                <br />
                                <li>
                                    Los datos personales no deben mantenerse más tiempo del necesario para cumplir su propósito.
                                </li>
                                <br />
                                <li>
                                    Las personas cubiertas por el INAI tienen derecho a acceder a sus propios datos personales.
                                    También pueden solicitar una copia de sus datos y que sus datos sean actualizados, eliminados,
                                    restringidos o transferidos a otra organización.
                                </li>

                                <br />
                                <br />

                                <h5> Derechos del sujeto de datos - Acceso a datos, portabilidad y eliminación</h5>
                                <p className='justify-content'>
                                    Estamos comprometidos a ayudar a nuestros clientes a cumplir con los requisitos de derechos de
                                    los sujetos de datos del INAI. KJ-LOGISTICS procesa o almacena todos los datos personales en
                                    proveedores totalmente evaluados y compatibles con DPA. Almacenamos todas las conversaciones y
                                    datos personales hasta mas de 2 años, a menos que se elimine tu cuenta. En cuyo caso, eliminamos
                                    todos los datos de acuerdo con nuestros Términos de Servicio y Política de Privacidad, pero no
                                    los conservaremos más de 60 días.
                                </p>

                                <br />
                                <br />
                                <h5> Contáctanos </h5>
                                <p className='justify-content'>
                                    No dudes en contactarnos si tienes alguna pregunta.

                                    <li className="correo"> Correo:
                                        <a href="mailto:operaciones@kj-logistics.com">
                                            operaciones@kj-logistics.com
                                        </a>
                                    </li>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AvisoPrivacidad